<template>
  <div id="mobile-nav">
    <slot name="mobile-navbar"></slot>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'

export default {
  name: "MobileNavbar",
  props: {},
  components: {},
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#mobile-nav {
  width: 100%;
}
</style>
